<template>
  <div>
    <!-- 顶部 -->
    <div class="trendtop orangeToYellow">
      <div class="trendtop_left fs40 ellipsis">
        <p>{{ $t('member.user_me11') }}</p>
      </div>
      <!-- <div class="trendtop_right fs24"></div> -->
    </div>
    <div class="content" v-if="!imgUrl">
      <div class="camera_area">
        <input
          class="camera"
          type="file"
          capture="camera"
          name="file"
          accept="image/*"
        />
        <div class="icon">
          <img
            src="./../../../assets/images/camera.png"
            alt=""
            width="120px"
            height="110px"
          />
          <div class="txt">点击打开相机拍照</div>
        </div>
      </div>
      <!-- 提示 -->
      <div class="tips_area">
        <div class="txt">
          *为了更精准识别到病虫害，请近距 离拍摄清晰的柑橘异常照片
        </div>
      </div>
      <!-- 按钮 -->
      <div class="btn_area">
        <div class="btn">上传照片</div>
        <input
          class="camera"
          type="file"
          name="file"
          accept="image/*"
          @change="handleChooseImgChange"
        />
      </div>
    </div>
    <div class="content" v-else>
      <div class="img_area">
        <img :src="imgUrl" alt="" />
      </div>
      <div class="btns_area">
        <div class="btn choose" @click="handleChoose">重新选择</div>
        <div class="btn check" @click="imgAICheck">识别</div>
      </div>
    </div>
  </div>
</template>

<script>
import * as ImageConversion from 'image-conversion'

export default {
  data() {
    return {
      imgUrl: '',
      catUrl: '',
    }
  },
  methods: {
    // 选择图片
    async handleChooseImgChange(e) {
      var e = window.event || e
      // 获取当前选中的文件
      var file = e.target.files[0]
      this.uploadImg(file)
    },

    // 图片上传
    async uploadImg(file) {
      await this.$toast.loading({
        message: '图片上传中',
        duration: 0,
        mask: true,
      })
      const validSize = 500 * 1024
      let compressFile = file
      if (file.size > validSize) {
        console.log('超过图片500k大小，进行压缩')
        compressFile = await ImageConversion.compressAccurately(file, 490)
      }
      await this.$api
        .uploadFile({ file: compressFile })
        .then(async (res) => {
          if (res.errcode !== 0) return this.$toast.fail(res.errmsg)

          if (res.url) {
            this.imgUrl = res.url
            this.catUrl = res.catUrl
          } else {
            this.$toast.fail({
              message: '上传文件未返回url',
            })
          }

          this.$toast.clear()
        })
        .catch((err) => {
          console.error(err)
          this.$toast.clear()
        })
    },

    // 重新选择
    handleChoose() {
      this.imgUrl = null
    },

    // 图片识别
    async imgAICheck() {
      // const reslut = {
      //   reslut: "柑橘木虱",
      //   core: 90.6,
      //   url:
      //     "https://api.ascod.cn/iotUser-api/upload/da895ad8-deeb-428b-ac2d-25301d4f5a68.JPEG"
      // };

      // return this.$router.push(
      //   `/identifyRelut/${encodeURIComponent(JSON.stringify(reslut))}`
      // );

      await this.$toast.loading({
        message: '图片识别中',
        duration: 0,
        mask: true,
      })

      await this.$api
        .scanImage({
          cropFlag: '1', // “1:柑橘 2:杂草 123:苹果 127:葡萄 131:小麦 132:水稻”
          imageUrl: this.catUrl,
        })
        .then((res) => {
          if (res.errcode === 0) {
            if (
              res.content.msg &&
              res.content.msg.indexOf('无法识别该物种') > -1
            ) {
              this.$toast.fail(res.content.msg)
            } else {
              this.$toast.clear()

              const result = {
                result: res.content.result,
                core: res.content.score,
                url: this.imgUrl,
              }
              return this.$router.push(
                `/identifyRelut/${encodeURIComponent(JSON.stringify(result))}`,
              )
            }
          } else {
            // this.$toast.fail(res.errmsg);
            this.$toast.fail('设备升级中')
          }

          setTimeout(() => {
            this.$toast.clear()
          }, 1500)
        })
        .catch((err) => {
          this.$toast.fail(err.errmsg)
          setTimeout(() => {
            this.$toast.clear()
          }, 1500)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.trendtop {
  height: 60px;
  overflow: hidden;
  line-height: 30px;
  padding: 15px 10px;
  width: 100%;
  box-sizing: border-box;
  z-index: 9999999999;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.3);
}
.trendtop .trendtop_left {
  float: left;
  color: #fff;
  padding: 0 0.4rem 0 0;
  position: relative;
  max-width: 3rem;
  font-size: 15px;
  font-weight: 700;
}

.camera_area {
  position: relative;
  height: 250px;
  background: #f9f9fb;
  border-radius: 5px;
  margin: 15px;
}

.icon {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100%;

  .txt {
    font-size: 14px;
    font-family: PingFang SC;
    color: #4171e5;
    font-weight: 500;
  }
}

.tips_area {
  background: #fff5eb;
  border-radius: 6px;
  margin: 15px;
  padding: 9px 15px;

  .txt {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 20px;
    color: #ff953d;
  }
}

.btn_area {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 44px;
  background: #4171e5;
  border-radius: 22px;
  margin: 45px 25px 0;
  text-align: center;

  .btn {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #ffffff;
  }
}

.img_area {
  margin: 15px;

  img {
    width: 100%;
  }
}

.btns_area {
  display: flex;

  .btn {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 42px;
    line-height: 42px;
    border: 1px solid #4171e5;
    border-radius: 38px;
    font-size: 16px;
    font-weight: 500;
    margin: 0 20px;
  }

  .choose {
    width: 120px;
    font-family: PingFang SC;
    color: #4171e5;
    margin-right: 15px;
    background: #ffffff;
  }

  .check {
    width: 200px;
    color: #ffffff;
    background: #4171e5;
  }
}

.camera {
  position: absolute;
  top: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
}
</style>
